import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";
import typescript from "highlight.js/lib/languages/typescript";
import xml from "highlight.js/lib/languages/xml";
import css from "highlight.js/lib/languages/css";
import json from "highlight.js/lib/languages/json";
import bash from "highlight.js/lib/languages/bash";
import markdown from "highlight.js/lib/languages/markdown";
import python from "highlight.js/lib/languages/python";

hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("js", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("ts", typescript);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("html", xml);
hljs.registerLanguage("css", css);
hljs.registerLanguage("json", json);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("sh", bash);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("md", markdown);
hljs.registerLanguage("python", python);
hljs.registerLanguage("py", python);

const ALIASES: Record<string, string> = {
  js: "javascript",
  ts: "typescript",
  html: "xml",
  htm: "xml",
  sh: "bash",
  md: "markdown",
  py: "python",
};

/**
 * Подсветка кода для markdown-блоков в чате.
 *
 * highlight.js экранирует вход, поэтому результат безопасен для {@html}.
 * Неизвестный язык — просто экранированный текст.
 */
export function highlight(code: string, lang: string): string {
  const requested = lang.toLowerCase().trim();
  const language = ALIASES[requested] ?? requested;

  if (language && hljs.getLanguage(language)) {
    try {
      return hljs.highlight(code, { language, ignoreIllegals: true }).value;
    } catch {
      /* падаем в обычный текст */
    }
  }
  return escapeHtml(code);
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}
